export interface PendingKlarnaPurchase {
  /** recurly 3ds action token that triggered the klarna redirect; re-run on return to mint the result token */
  actionTokenId: string;
  /** the one-time klarna confirmation token, resubmitted with the purchase (recurly needs both) */
  stripeConfirmationToken: string;
  /** buyer email for conversion tracking on the resumed purchase (in-memory params are lost on redirect) */
  email: string;
  createdAt: number;
}

const STORAGE_KEY = 'fi_pending_klarna_purchase';

/**
 * Klarna's redirect is a full page navigation away from checkout, so everything the return needs
 * to finish the order (beyond the redux-persisted cart/session/checkout state) is stashed here.
 * localStorage rather than sessionStorage because mobile browsers can restore the return
 * navigation in a fresh tab after the klarna app switch, which would lose sessionStorage.
 */
const EXPIRY_MS = 30 * 60 * 1000;

export function savePendingKlarnaPurchase(pending: PendingKlarnaPurchase) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
  } catch {
    // storage full/unavailable — the redirect will still happen; the return just can't resume
  }
}

export function loadPendingKlarnaPurchase(): PendingKlarnaPurchase | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const pending: PendingKlarnaPurchase = JSON.parse(raw);
    if (!pending.actionTokenId || !pending.stripeConfirmationToken || Date.now() - pending.createdAt > EXPIRY_MS) {
      clearPendingKlarnaPurchase();
      return null;
    }
    return pending;
  } catch {
    return null;
  }
}

export function clearPendingKlarnaPurchase() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
